import { schema } from 'normalizr';
import paginateAction from '@utils/paginateAction';
import { classTypes } from '../constants';
import { itemSchema, paginatorListSchema } from '../schemas';

export const fetchClassDetails = (uid) => (dispatch) =>
  dispatch({
    type: classTypes.FETCH_CLASS,
    endpoint: `v1/uplus/classes/${uid}/details/`,
    method: 'get',
    uid,
    schema: new schema.Object({ item: itemSchema }),
    entityType: 'item',
    processData: (data) => {
      const newData = data;
      newData.programmeUid = newData.programme.uid || newData.collection.uid;
      delete newData.programme;
      delete newData.collection;
      return newData;
    }
  });

const getSimilarAndOtherCourses = (uid) => (next) => ({
  type: classTypes.FETCH_SIMILAR_AND_OTHER_COURSES,
  endpoint: next,
  method: 'get',
  key: uid,
  resetWithoutEmpty: false,
  schema: paginatorListSchema,
  directPaginatedEntity: true,
  entityType: 'feedrow',
  processData: (data) => {
    const newData = data;
    newData.results = newData.results.map((resultItem) => ({
      ...resultItem,
      key: uid,
      data: resultItem.data.map((dataRow) => ({
        ...dataRow,
        ...dataRow.programme
      }))
    }));
    return newData;
  }
});

export const fetchSimilarAndOtherCourses = (uid) =>
  paginateAction(
    `v1/search_v3/special_classes/${uid}/v2/`,
    getSimilarAndOtherCourses(uid),
    'similarAndOtherCourses',
    uid,
    false
  )(false);

export const sendWatched = (uid) => (dispatch) =>
  dispatch({
    type: classTypes.SEND_WATCHED,
    endpoint: `v1/post/${uid}/track/`,
    method: 'post'
  });

export const sendWatchedPrevious = (uid) => (dispatch) =>
  dispatch({
    type: classTypes.SEND_WATCHED_PREVIOUS,
    endpoint: `v1/uplus/classes/${uid}/watched/`,
    method: 'post'
  });

export const submitLiveClassReview = (review) => (dispatch) =>
  dispatch({
    type: classTypes.LIVE_CLASS_FEEDBACK,
    endpoint: 'v1/uplus/live-class-review/',
    method: 'post',
    data: {
      live_class_uid: review.live_class_uid,
      is_liked: review.is_liked,
      review_text: review.review_text,
      suggestions: review.suggestions
    }
  });

export const sendFreeVideoWatched = (uid) => (dispatch) =>
  dispatch({
    type: classTypes.SEND_WATCHED,
    endpoint: `v1/post/${uid}/watched/`,
    method: 'post',
    uid
  });

export const updateView = (uid) => (dispatch) =>
  dispatch({
    type: classTypes.UPDATE_PAGEVIEW,
    endpoint: `v1/analytics/post/${uid}/`,
    method: 'post',
    uid
  });

export const fetchScheduledClasses = (
  goalUid,
  url = '',
  direction,
  resetWithoutEmpty = false
) => (dispatch) =>
  dispatch({
    type: classTypes.FETCH_SCHEDULED_CLASSES,
    endpoint: url,
    method: 'get',
    schema: {
      results: [{ item: itemSchema }]
    },
    key: `${goalUid}`,
    direction,
    resetWithoutEmpty,
    processData: (results) => {
      const newResults = [];
      if (results.results) {
        results.results.map((item) => {
          const itemData = item.data;
          itemData.thumbnail =
            item.data?.post_thumbnail || item.data?.programme?.cover_photo;
          itemData.type = item.type;
          delete itemData.programme;
          newResults.push({
            type: item.type,
            item: itemData,
            date: item.date
          });
          return item;
        });
      }
      return {
        ...results,
        results: newResults
      };
    }
  });

export const fetchCalendarData = (goalUid, time) => (dispatch) =>
  dispatch({
    type: classTypes.FETCH_CALENDAR_DATA,
    endpoint: `v1/uplus/subscription/count/?goal_uid=${goalUid}&epoch_time=${Math.round(
      time / 1000
    )}&timezone_difference=330`,
    method: 'get',
    month: new Date(time).getMonth()
  });
